import React from "react";
import { makeStyles } from "@material-ui/core/";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import VisibilitySensor from "react-visibility-sensor";

import consultationServices from "../info/consultationServices";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#ffc522",
    padding: "3rem 2rem",
    transition: "all .3s smooth",
  },
  consultationServices: {
    display: "flex",
    justifyContent: "center",
    padding: "2em 2em 0 2em",
  },
  consultationServiceCard: {
    background: "#f5dd3a",
    color: "#1c4c99",
    height: "5em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "3px solid #1c4c99",
    borderRadius: "1em",
    [theme.breakpoints.up("sm")]: {
      borderRadius: "2em",
    },
  },
}));

const ConsultationServices = ({ refProp, setRefInView }) => {
  const classes = useStyles();
  return (
    <VisibilitySensor
      partialVisibility
      // minTopValue={100}
      onChange={(isVisible) =>
        isVisible && setRefInView("consultationServices")
      }
    >
      {({ isVisible }) => (
        <div
          ref={refProp}
          className={classes.root}
          style={{
            opacity: `${isVisible ? "1" : "0.25"}`,
          }}
        >
          <Typography variant="h4" style={{ fontWeight: "600" }}>
            {"Consultation Services"}
          </Typography>
          <div>
            <Grid
              container
              spacing={3}
              className={classes.consultationServices}
            >
              {consultationServices.map((s, idx) => (
                <Grid item key={idx} xs={12} sm={4} md={3} xl={2}>
                  <Card
                    className={classes.consultationServiceCard}
                    variant="outlined"
                  >
                    <CardContent
                      className={classes.consultationServiceCardContent}
                    >
                      <Typography style={{ fontWeight: "900" }}>{s}</Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
      )}
    </VisibilitySensor>
  );
};

export default ConsultationServices;
